"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "userListCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $http,
      $filter,
      permissionService,
      settings,
      apiSettings,
      list,
      MessageService,
      User
    ) {
      var vm = this;

      vm.permissions = permissionService;
      if (!vm.permissions.isAdminAccessAuthorized()) return;

      var $translate = $filter("translate");

      angular.extend($scope.$parent.vm, {
        title: "users.settings.title",
        insertUrl: "main.user-edit",
      });

      vm.projectModule = config.projectModule;

      $rootScope.laddaLoading = false;

      // Pagination
      vm.pagination = {
        list: list,
        currentPage: 1,
        pageSize: apiSettings.defaultPageSize,
        pagesTotal: list.total,
      };

      vm.onlyApprovedUsers = true;

      $scope.$watch("vm.keyword", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          vm.refresh(vm.pagination.currentPage, newValue);
        }
      });

      $scope.$watch("vm.pagination.currentPage", function (newValue, oldValue) {
        if (newValue !== oldValue) {
          vm.refresh(newValue, vm.keyword);
        }
      });

      vm.filterUsers = function () {
        User.list({
          page: vm.pagination.currentPage,
          keyword: vm.keyword,
          onlyApprovedUsers: vm.onlyApprovedUsers,
        }).$promise.then(function (data) {
          vm.pagination.list = data;
          vm.pagination.currentPage = data.page;
          vm.pagination.pagesTotal = data.total;
        });
      };

      vm.refresh = function (page, keyword) {
        User.list({ page: page, keyword: keyword }).$promise.then(function (
          data
        ) {
          vm.pagination.list = data;
          vm.pagination.currentPage = data.page;
          vm.pagination.pagesTotal = data.total;
        });
      };

      vm.delete = function (id, index) {
        MessageService.confirmDelete(function () {
          User.delete({ id: id }, function () {
            vm.pagination.list.rows.splice(index, 1);
          });
        });
      };
    }
  );
